module.exports = __webpack_public_path__ + "img/ez-slot-ic-menu-bonus.651d106f.png";